
export default () => ({
  statusContainer: {
    display: 'inline-block',
    overflow: 'auto',
    marginRight: 60,
  },
  statusColumn: {
    display: 'inline-block',
    verticalAlign: 'top',
    width: 300,
    marginRight: 8 * 2,
  },
  statusHeaderContainer: {
    display: 'inline-block',
    padding: 12,
    textAlign: 'center',
    width: '100%',
  },
  card: {
    marginTop: 8 * 2,
    height: '100%',
  },
  cardHeader: {
    alignItems: 'center',
    padding: 16,
  },
  cardContent: { padding: '0 1em 1em 1em' },
  avatar: { marginRight: '.5em' },
});
